import React from "react";

const Email = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50317 9.75406L10.4299 11.5585C11.3956 12.1538 12.6145 12.1538 13.5802 11.5585L16.5069 9.75406"
        stroke="#050505"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3.00122"
        y="5.00209"
        width="18.0075"
        height="14.0058"
        rx="3"
        stroke="#050505"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Email;
